// src/components/prayers/PrayerFormProps.ts
import * as z from 'zod';

// Shared schema for both PrayerForm and EditPrayerForm
export const prayerSchema = z.object({
  // Title is optional, max 100 chars → store null if empty
  title: z.string().max(100).nullable().optional(),

  // Prayer Request (content) is REQUIRED and must be at least 10 chars
  content: z
    .string()
    .min(10, 'Prayer content must be at least 10 characters')
    .max(2000),

  // Category is optional → store null if empty
  category: z.string().nullable().optional(),

  // Privacy is optional, default to 'public'
  visibility: z.enum(['public', 'private']).default('public').optional(),
});

export type PrayerFormData = z.infer<typeof prayerSchema>;

// Props for PrayerForm (new prayer submit)
export interface PrayerFormProps {
  onSubmit: (data: PrayerFormData) => Promise<void>;
  isSubmitting?: boolean;
  onCancel?: () => void;
  showActions?: boolean;
}

// Props for EditPrayerForm (edit existing prayer)
export interface EditPrayerFormProps {
  defaultValues: PrayerFormData;
  onSubmit: (data: PrayerFormData) => Promise<void>;
  isSubmitting?: boolean;
  onCancel?: () => void;
}
